
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../base/Button';
import { AuthModal } from './AuthModal';
import { useAuth } from '../../modules/auth/hooks/useAuth';
import { LogoutButton } from '../../modules/auth/ui/LogoutButton';

export default function Header() {
  const [activeSection, setActiveSection] = useState('Dashboard');
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  
  const menuItems = ['Dashboard', 'Ingresos', 'Egresos', 'Presupuestos', 'Reportes'];
  
  const handleAuthSuccess = () => {
    navigate('/dashboard');
  };
  
  return (
    <>
      <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <div className="flex items-center">
                <h1 className="text-2xl font-bold text-emerald-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  Invirtiendo
                </h1>
              </div>
              
              <nav className="hidden md:flex space-x-8">
                {menuItems.map((item) => (
                  <button
                    key={item}
                    onClick={() => {
                      setActiveSection(item);
                      if (item === 'Presupuestos') {
                        navigate('/presupuestos');
                      } else {
                        navigate('/dashboard');
                      }
                    }}
                    className={`px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                      activeSection === item
                        ? 'text-emerald-600 border-b-2 border-emerald-600'
                        : 'text-gray-600 hover:text-emerald-600'
                    }`}
                  >
                    {item}
                  </button>
                ))}
              </nav>
            </div>
            
            <div className="flex items-center space-x-4">
              {user ? (
                <>
                  <span className="text-sm text-gray-600">
                    Hola, {user.email}
                  </span>
                  <LogoutButton />
                </>
              ) : (
                <>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => navigate('/login')}
                  >
                    Iniciar Sesión
                  </Button>
                  <Button 
                    size="sm"
                    onClick={() => navigate('/plans')}
                  >
                    Empezar Gratis
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
      
      <AuthModal 
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        onSuccess={handleAuthSuccess}
      />
    </>
  );
}
